import React from 'react'

function MedicineItemMaster() {
  return (
    <div>Medicine / Item Master</div>
  )
}

export default MedicineItemMaster